import React from "react";
import Panel from "../Panel";
import { Main } from "./styles";

const SharedPublic: React.FC = ({
	children
}) => (
	<Main fullScreenMode>
		<Panel>
			{children}
		</Panel>
	</Main>
);

export default SharedPublic;
